import * as firebase from "firebase/app";
import "firebase/messaging";
import {toast} from "react-toastify";

import {addFirebaseToken, revokeFirebaseToken} from "./thunks/Notifications";
import {store} from "./configureStore";


let messaging = undefined;
if (firebase.messaging.isSupported()) {
    const initializedFirebaseApp = firebase.initializeApp({
        apiKey: "AIzaSyAmgYmVOoBR6sreyDKgSAMDvV-gaXlxdOA",
        authDomain: "testhightouch-fbf9a.firebaseapp.com",
        projectId: "testhightouch-fbf9a",
        storageBucket: "testhightouch-fbf9a.appspot.com",
        messagingSenderId: "771919394318",
        appId: "1:771919394318:web:50b2023bc4ce6ccfed2e5f"
    });
    messaging = initializedFirebaseApp.messaging();

    messaging.usePublicVapidKey(
        // Project Settings => Cloud Messaging => Web Push certificates
        "BHKN1nH4dylrEGM2nFmOjgzc9D45bT_w6Dq20-Ptq8mp269dmdW0WUMO9r_ZUjmMy43fPAuv7_uvSWU_ZUbzz98"
    );

    messaging.onTokenRefresh(() => {
        const oldToken = store.getState().Notifications.firebaseToken;

        messaging.getToken().then((refreshedToken) => {
            // Indicate that the new Instance ID token has not yet been sent to the
            // app server.
            // console.log('Token refreshed.');
            oldToken && store.dispatch(revokeFirebaseToken(oldToken));
            // Send Instance ID token to app server.
            store.dispatch(addFirebaseToken(refreshedToken));
        }).catch((err) => {
            // console.log('Unable to retrieve refreshed token ', err);
            oldToken && store.dispatch(revokeFirebaseToken(oldToken));
        });
    });
}

const requestPermission = () => {
    if (!('Notification' in window) || messaging === undefined) {
        toast.error('Browser notifications are not supported!');
        return;
    }

    const oldToken = store.getState().Notifications.firebaseToken;

    messaging.requestPermission()
        .then(async () => {
            const token = await messaging.getToken();
            store.dispatch(addFirebaseToken(token, () => toast.success('Notifications enabled')));
        })
        .catch(function (err) {
            toast.error("Permission not granted!");
            console.error(err)
            oldToken && store.dispatch(revokeFirebaseToken(oldToken));
        });

    navigator.serviceWorker.addEventListener("message", (message) => console.log(message));
}

export {messaging, requestPermission};
